import { createSelector, createSlice } from '@reduxjs/toolkit';
export const initialStateLoginWithLinkedIn = {
    givenName: null,
    isRedirecting: false,
};
export const LoginWithLinkedInSlice = createSlice({
    name: 'loginWithLinkedIn',
    initialState: initialStateLoginWithLinkedIn,
    reducers: {
        setIsRedirecting: (state, actions) => {
            state.isRedirecting = actions.payload;
        },
        setGivenName: (state, actions) => {
            state.givenName = actions.payload;
        },
    },
});
export const { setGivenName, setIsRedirecting } = LoginWithLinkedInSlice.actions;
const loginWithLinkedInState = (state) => state.features.loginWithLinkedIn;
export const givenNameSelector = createSelector(loginWithLinkedInState, ({ givenName }) => givenName);
export const redirectingStatusSelector = createSelector(loginWithLinkedInState, ({ isRedirecting }) => isRedirecting);
export default LoginWithLinkedInSlice.reducer;
//# sourceMappingURL=loginWithLinkedInSlice.js.map